import { Stack, Typography } from '@mui/material';

import StatusBadge from '@/components/StatusBadge';
import { DeploymentStatus } from '@/graphql';
import { SharedEndpointIconSize } from '@/sections/SharedEndpoints/Icons/types';
import { mapModelFamilyToIcon } from '@/sections/SharedEndpoints/utils';

import { usePinnedAPI } from '../../Models/hooks';
import { CardNameContainer, ModelData, StatusContainer } from '../../styled';
import Actions from '../Actions';
import { CardProps } from './types';

function SharedEndpoint({ orgSharedEndpoint, isSpendExceeded }: CardProps) {
  const Icon = mapModelFamilyToIcon(orgSharedEndpoint.sharedEndpoint.modelFamily);
  const { getPinActionItem } = usePinnedAPI();

  return (
    <ModelData flex={1} justifyContent="space-between">
      <Stack gap={1.5} pt={2} pb={2.5} pl={2.5} pr={2} flex={1}>
        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <CardNameContainer>
              <Icon size={SharedEndpointIconSize.SMALL} />
              <Typography
                variant="h4"
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {orgSharedEndpoint.sharedEndpoint.name}
              </Typography>
            </CardNameContainer>

            <Stack direction="row" gap={0.2}>
              {getPinActionItem(orgSharedEndpoint.id, orgSharedEndpoint.sharedEndpoint.name)}
              <Actions
                variant="minimal"
                sharedEndpointId={orgSharedEndpoint.id}
                sharedEndpointName={orgSharedEndpoint.sharedEndpoint.name}
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <StatusContainer>
        <StatusBadge
          status={isSpendExceeded ? DeploymentStatus.ModelDneError : DeploymentStatus.ModelReady}
          label={isSpendExceeded ? 'Budget reached' : 'Model API'}
          // do not show tooltip
          tooltip=""
        />
      </StatusContainer>
    </ModelData>
  );
}

export default SharedEndpoint;
